<template>
  <v-row no-gutters class="top-bar" align="center" style="height: 4.5rem" :style="`background: ${config.top_bar_background_color}`">
    <!-- icon -->
    <v-col cols="auto" style="height: 2.5rem; width: 3rem">
      <v-img class="top-bar-img" :src="config.logo_url" alt="Chatbot Icon">
        <template v-slot:placeholder>
          <v-skeleton-loader type="image" />
        </template>
      </v-img>
    </v-col>

    <!-- title -->
    <v-col cols="auto" style="width: calc(100% - 11rem)">
      <v-row no-gutters :style="`color: ${config.text_color}`">
        <span class="top-bar-title ellipsis-text">{{ top_bar_title }}</span>
      </v-row>
      <v-row no-gutters :style="`color: ${config.text_color}`">
        <span class="top-bar-subtitle ellipsis-text">{{ top_bar_subtitle }}</span>
      </v-row>
    </v-col>

    <!-- language -->
    <v-col cols="auto" v-if="route.path === '/chat'">
      <v-menu ref="language_menu" transition="slide-y-transition" offset-y close-on-content-click content-class="language-menu">
        <template #activator="{ props }">
          <v-chip v-if="config.languages?.length" outlined small class="language-chip" :style="`color: ${config.text_color}`" v-bind="props" role="button"
            ><v-icon>mdi-web</v-icon>{{ language }}</v-chip
          >
        </template>
        <v-card style="padding: 0.5rem 0">
          <v-list aria-label="header-language-list">
            <v-list-item v-for="(item, i) in language_list" :key="i" class="language-menu-text" @click="updateLanguage(item.payload)">{{ item.short_name }}</v-list-item>
          </v-list>
        </v-card>
      </v-menu>
    </v-col>
  </v-row>
</template>

<script setup>
// import config
import global_config from '@/../config.json'
// Import modules
import { computed, ref } from 'vue'
import { useRoute } from 'vue-router'
import { useLocale } from 'vuetify'
import { useStore } from 'vuex'

// Init modules
const { current } = useLocale()
const store = useStore()
const route = useRoute()

// data
const config = ref(global_config)

// computed
const language = computed(() => {
  let socket_language = store.state.i18n.socket_language
  let language_shortname = config.value.languages?.filter((language) => language.payload === socket_language)[0].short_name

  return language_shortname
})

const language_list = computed(() => {
  return config.value.languages
})

const top_bar_title = computed(() => {
  let socket_language = store.state.i18n.socket_language
  return config.value[`top_bar_title_${socket_language}`] || config.value['top_bar_title']
})

const top_bar_subtitle = computed(() => {
  let socket_language = store.state.i18n.socket_language
  return config.value[`top_bar_subtitle_${socket_language}`] || config.value['top_bar_subtitle']
})

// methods
const updateLanguage = (language) => {
  store.commit('SET_CHAT_LOADING', true)
  store.commit('SET_I18N_LANGUAGE', language)
  store.dispatch('updateSocketServer')
  store.commit('SET_CHAT_HISTORY', [])
  // Switch multiple language use vuetify
  switch (language) {
    case 'cantonese':
      current.value = 'zhHant-HK'
      break
    case 'mandarin':
      current.value = 'zhHant'
      break
    case 'putonghua':
      current.value = 'zhHans'
      break
    case 'english':
      current.value = 'en'
      break
    case 'japanese':
      current.value = 'ja'
      break
    case 'korean':
      current.value = 'ko'
      break
  }
}
</script>

<style scoped>
.top-bar {
  padding: 0 1rem;
}

.top-bar-img {
  margin-right: 0.5rem;
  max-width: 2.5rem;
  border-radius: 1.25rem;
  /* animation: fade 0.75s; */
}

.top-bar-title {
  font-weight: 700;
  font-size: 1rem;
  line-height: 1.375rem;
  animation: fade 0.75s;
}

.top-bar-subtitle {
  font-weight: 400;
  font-size: 0.6875rem;
  line-height: 0.9375rem;
  animation: fade 0.75s;
}

@keyframes fade {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.v-list-item {
  min-height: 2rem !important;
  height: 2rem !important;
}

.language-menu {
  border-radius: 0.5rem;
  box-shadow: 0 0.25rem 0.3125rem rgba(0, 0, 0, 0.14), 0 0.0625rem 0.625rem rgba(0, 0, 0, 0.12), 0 0.125rem 0.25rem rgba(0, 0, 0, 0.2) !important;
}

.language-chip {
  margin-left: 1rem;
  border: 0.0625rem solid #ffffff;
  position: absolute;
  top: 1rem;
  right: 3.75rem;
}

.language-menu-text {
  font-weight: 400;
  font-size: 0.9375rem;
  line-height: 1.375rem;
  letter-spacing: 0.01875rem;
  color: #1b1b1b;
  padding: 0.3125rem 1rem;
  cursor: pointer;
}
</style>
